export default __webpack_public_path__ + "static/media/sponsor4.4dd22451.jpg";